export default "__VITE_ASSET__DK7A$RU8__"